import React, { FC } from 'react'
import s from './CardArticle.module.scss'
import { IArticles } from '../../store/types'
import { truncateText } from '../../utils'
import { motion } from 'framer-motion'

interface dataProps {
    setSelectedId: (id: string | null) => void;
    data: null | IArticles
    setData: React.Dispatch<React.SetStateAction<IArticles | null>>;
}
const CardArticle: FC<dataProps> = ({ data, setData, setSelectedId }) => {
    const idString = data?.id.toString() || undefined;

    return (
        <motion.div
            layoutId={idString}
            onClick={() => {
                setData(data)
                setSelectedId(idString ?? null)
            }}
        >
            <div className={s.card}>
                <div className={s.date}>
                    <p>Дата выпуска:</p>
                    <span>{data?.publishedAt}</span>
                </div>
                <div className={s.box_content}>
                    <h2>{data?.title}</h2>
                    <p>{truncateText(data?.preview_text, 50)}</p>
                </div>
                <div className={s.btn}>
                    <button>Узнать больше</button>
                </div>
            </div>
        </motion.div>
    )
}

export default CardArticle